import { SerializerOperator } from './SerializerOperator.ts';

export class DateFormatter extends SerializerOperator<Date> {
    // Define the pattern for date formatting in local time
  private pattern: string;
  private static symbols: Record<string, (date: Date) => string> = {
    'dd': (date: Date) => date.getDate().toString().padStart(2, '0'),
    'MM': (date: Date) => (date.getMonth() + 1).toString().padStart(2, '0'),
    'yyyy': (date: Date) => date.getFullYear().toString(),
    'hh': (date: Date) => date.getHours().toString().padStart(2, '0'),
    'mm': (date: Date) => date.getMinutes().toString().padStart(2, '0'),
    'ss': (date: Date) => date.getSeconds().toString().padStart(2, '0'),
    'SSS': (date: Date) => date.getMilliseconds().toString().padStart(3, '0'),
    'XXX': (date: Date) => {
      const offset = -date.getTimezoneOffset();
      const hours = Math.floor(Math.abs(offset / 60)).toString().padStart(2, '0');
      const minutes = (Math.abs(offset) % 60).toString().padStart(2, '0');
      return `${offset >= 0 ? '+' : '-'}${hours}:${minutes}`;
    },
    'A': (date: Date): string => (date.getHours() >= 12 ? 'PM' : 'AM'),
  };

  constructor(pattern: string) {
    super();
    this.pattern = pattern;
  }

  private partialMatch(symbol: string): boolean {
    return Object.keys(DateFormatter.symbols).some(key => key.startsWith(symbol));
  }

  private symbol2value(symbol: string, date: Date): string | null {
    if (DateFormatter.symbols[symbol]) {
      return DateFormatter.symbols[symbol](date);
    } else if (this.partialMatch(symbol)) {
      return null;
    } else {
      return symbol;
    }
  }

  public format(date: Date): string {
    let result = '';
    let buffer = '';
    for (const symbol of this.pattern) {
        const value = this.symbol2value(buffer + symbol, date);
        if (value !== null) {
          result += value;
          buffer = '';
        } else {
          buffer += symbol;
        }
    }
    return result + buffer;
  }
}